class rStarRating {
    constructor() {
        this.starsHolder = document.querySelector('.js-star-rating-interactive')

        if (!this.starsHolder) {
            return
        }

        this.fullStarsEl = this.starsHolder.querySelector('.js-star-rating-full')
        this.ratingInputElements = this.starsHolder.querySelectorAll('input[name="rating"]')

        for (const inputEl of this.ratingInputElements) {
            for (const inputLabelEl of inputEl.labels) {
                inputLabelEl.addEventListener('mouseenter', this.onMouseEnter.bind(this))
                inputLabelEl.addEventListener('mouseleave', this.onMouseLeave.bind(this))
            }

            inputEl.addEventListener('change', this.onChange.bind(this))
        }
    }

    get currentRatingValue() {
        return this.starsHolder.querySelector('input[name="rating"]:checked').value
    }

    getPercentageWidth(rating) {
        return `${rating / 5 * 100}%`
    }

    setStarsWidth(rating) {
        this.fullStarsEl.style.width = this.getPercentageWidth(rating)
    }

    onMouseEnter(event) {
        this.setStarsWidth(event.target.control.value)
    }

    onMouseLeave() {
        this.setStarsWidth(this.currentRatingValue)
    }

    onChange() {
        this.setStarsWidth(this.currentRatingValue)
    }
}

new rStarRating()
